import { Outlet } from "react-router"

export const Bookings = () => (
    <div>
        <Outlet/>
    </div>
)
